import { Wrapper, TestimonialsWrapper, Title, CardContainer } from './styles';
import Card from './card';

const profiles = [
    {
        avatar: '/images/testimonials/sumeet.svg',
        name: 'Sumeet Choudhary',
        position: 'Director, Lendingkart',
        review: '“ACKO has done an excellent job in capturing our vision of delivering outstanding value to our customers. The principle of making insurance simple and comprehensible with their online process has struck a chord with our customer base. This has made a significant business impact.”',
    },
    {
        avatar: '/images/testimonials/rikant.svg',
        name: 'Rikant Pitti',
        position: 'Co-founder, EaseMytrip.com',
        review: '“Working with ACKO, as our trusted partner has been a pleasure. While we are committed to providing our customers with the best experience on their travel, ACKO’s digital insurance further substantiates our core values. A seamless experience when it comes to travel or even while making a claim.”',
    },
    {
        avatar: '/images/testimonials/anuj.svg',
        name: 'Anuj Kacker',
        position: 'Co-founder, MoneyTap',
        review: '“When providing financial help to our customers, we wanted to collaborate with a partner who would give us an edge and help us achieve long-term success. Enhancing the customer experience was our priority and ACKO was an unequivocal choice for their diverse offerings. We are happy to say that ACKO has been a true technology partner. Looking to cross many milestones together”',
    },
];

const Testimonials = () => {
    return (
        <Wrapper>
            <TestimonialsWrapper>
                <Title>Testimonials</Title>
                <CardContainer>
                    {profiles?.map((profile) => {
                        const { avatar, name, position, review } = profile;

                        return (
                            <Card
                                key={name}
                                avatar={avatar}
                                name={name}
                                position={position}
                                review={review}
                            />
                        );
                    })}
                </CardContainer>
            </TestimonialsWrapper>
        </Wrapper>
    );
};

export default Testimonials;
